// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"a53b9773","255":"39ad53a9","496":"1ed9a46c","647":"815c8e7f"}[chunkId] + ".chunk.js";
};